import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Phone, Mail } from "lucide-react";
import { useLanguage } from "../i18n";

export default function Footer() {
  const { t } = useLanguage();
  const depts = t("departments.items");

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24">
        <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
          <div className="max-w-md">
            <img src="/logo.webp" alt="GTECH SRL" className="h-12 w-auto" />
            <p className="mt-6 text-base leading-relaxed text-neutral-400">{t("footer.tagline")}</p>
          </div>
          <Link
            to="/contact"
            data-testid="footer-cta-quote"
            className="group inline-flex w-fit items-center gap-3 border border-white/20 px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-white transition-colors hover:border-brand-yellow hover:text-brand-yellow"
          >
            {t("header.cta")}
            <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-yellow">{t("footer.sitemap")}</p>
            <ul className="mt-5 space-y-3 text-sm text-neutral-400">
              <li><Link data-testid="footer-link-home" to="/" className="transition-colors hover:text-white">{t("nav.home")}</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="transition-colors hover:text-white">{t("nav.about")}</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="transition-colors hover:text-white">{t("nav.services")}</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-white">{t("nav.contact")}</Link></li>
            </ul>
          </div>
          <div className="col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-yellow">{t("footer.deptTitle")}</p>
            <ul className="mt-5 grid grid-cols-2 gap-3 text-sm text-neutral-400">
              {depts.map((d, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="h-1 w-1 bg-brand-yellow" />
                  {d.name}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-yellow">{t("footer.contactTitle")}</p>
            <ul className="mt-5 space-y-3 text-sm text-neutral-400">
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-yellow" />
                <span><span className="text-neutral-500">{t("footer.hq")}:</span><br />Via Ca Nove 1/8, 37036 S. Martino Buon Albergo (VR)</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-yellow" />
                <span><span className="text-neutral-500">{t("footer.legal")}:</span><br />Via Don Giovanni Bosco 8, 37060 Lugagnano di Sona (VR)</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 shrink-0 text-brand-yellow" />
                <a data-testid="footer-email" href="mailto:info@gtechitalia.it" className="transition-colors hover:text-white">info@gtechitalia.it</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 shrink-0 text-brand-yellow" />
                <a data-testid="footer-phone" href="tel:+390454514532" className="transition-colors hover:text-white">045 451 4532</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-neutral-500 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright">© 2026 GTECH SRL — {t("footer.rights")}</p>
          <p>{t("footer.vat")}</p>
        </div>
      </div>
    </footer>
  );
}
